import PhoneInput from 'react-phone-input-2'
import { useMainContext } from '../core/contexts/main'
import { useMemo } from 'react'
import { useGetBannedCountries } from '../core/services/react-query/useAuthQuery'
import React from 'react'

const MobileInput = (props) => {
	const {
		main: { theme },
	} = useMainContext()

	const isDark = useMemo(() => {
		return theme === 'dark'
	}, [theme])

	const { data: bannedCountries } = useGetBannedCountries()

	return (
		<PhoneInput
			inputClass={`${isDark && 'dark-phone-input'}`}
			buttonClass={`${isDark && 'dark-phone-btn'}`}
			dropdownClass={`${isDark && 'dark-phone-dropdown'}`}
			searchClass={`${isDark && 'dark-phone-search'}`}
			country={props.country || 'ae'}
			excludeCountries={bannedCountries?.map((d) => d.country) || []}
			enableSearch
			{...props}
		/>
	)
}

export default MobileInput
